import { Suspense } from 'react';
import { Flex, Spinner, StackScreen, useScreenSize } from '@banhala/ui-kit';
import { AnalyticsScreen } from 'shared/src/context';
import { SideMenu } from './components/SideMenu';
import { CategoryContent } from './components/CategoryContent';
import { IconSummaryList } from './components/IconSummaryList';
import { useOverviewCategories } from './queries/useOverviewCategories';
import { useIconsSummary } from './queries/useIconsSummary';
import { useScrollSync } from './hooks/useScrollSync';
import { useLogViewOverview } from './hooks/useLogViewOverview';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { useHasBeenFocusedTab } from 'shared/src/hooks';

const CategoryScreenContent = () => {
  useLogViewOverview();
  const { data } = useOverviewCategories();
  const categories = data.item_list;

  const { data: iconsData } = useIconsSummary();
  const icons = iconsData?.icon_list ?? [];

  const {
    activeIndex,
    contentRef,
    sideMenuRef,
    handleSectionLayout,
    handleContentScroll,
    handleContentMomentumScrollEnd,
    handleMenuPress,
  } = useScrollSync();

  const { width: screenWidth } = useScreenSize();

  return (
    <Flex flex={1} width={screenWidth}>
      {icons.length > 0 && <IconSummaryList icons={icons} />}
      <Flex.Row flex={1}>
        <Flex flex={1}>
          <SideMenu
            categories={categories}
            activeIndex={activeIndex}
            scrollViewRef={sideMenuRef}
            onMenuPress={handleMenuPress}
          />
        </Flex>
        <Flex flex={2.27}>
          <CategoryContent
            categories={categories}
            contentRef={contentRef}
            onScroll={handleContentScroll}
            onMomentumScrollEnd={handleContentMomentumScrollEnd}
            onSectionLayout={handleSectionLayout}
          />
        </Flex>
      </Flex.Row>
    </Flex>
  );
};

export const CategoryScreen = () => {
  const { hasBeenFocused } = useHasBeenFocusedTab();

  return (
    <AnalyticsScreen screen="OVERVIEW" hostsModals={false}>
      <StackScreen
        title={'카테고리'}
        hideBackButton={true}
        rightIcons={[<SearchIcon />, <CartIcon />]}
      >
        <Suspense
          fallback={
            <Flex.Center flex={1}>
              <Spinner />
            </Flex.Center>
          }
        >
          <Flex flex={1} alignItems={'center'}>
            {hasBeenFocused && <CategoryScreenContent />}
          </Flex>
        </Suspense>
      </StackScreen>
    </AnalyticsScreen>
  );
};
